module.exports = __webpack_public_path__ + "img/tp-101-2.8fac3738.png";